import { gql } from "apollo-boost";

export const fragments = {
  user: gql`
    fragment UserQueryUser on User {
      id
      name
      email
      phone
      role
      deactivated
      receiveNotifications
    }
  `
};

export default gql`
  query UserQuery($id: ID!) {
    user(id: $id) {
      ...UserQueryUser
    }
  }
  ${fragments.user}
`;



// WEBPACK FOOTER //
// ./src/queries/User.js